import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { INSPECTOR_SEARCH_START_LOADING, INSPECTOR_SEARCH_END_LOADING, INSPECTOR_SEARCH_LOADED, SET_INSPECTOR_FILTER } from "../constants/InspectorConstants";
import { INSPECTOR_START_LOADING, INSPECTOR_END_LOADING, INSPECTOR_LOADED } from "../constants/InspectorConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const InspectorReducer = (state = initialState, action) => {
    switch(action.type) {
        case INSPECTOR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case INSPECTOR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case INSPECTOR_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_INSPECTOR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case INSPECTOR_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case INSPECTOR_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case INSPECTOR_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default InspectorReducer;